module.exports = __webpack_public_path__ + "img/folder.721602d7.svg";